import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 토스트 한 칸. 띄운 뒤 3초 지나면 스스로 사라진다 */
export type ToastState = {
    isShow: boolean
    text: string
    timeoutID?: ReturnType<typeof setTimeout>
}

const state: ToastState = {
    isShow: false,
    text: '',
    timeoutID: undefined,
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'setToast': (store: Store, param: ToastState): void => {
        param.timeoutID = setTimeout(() => {
            store.commit('muToast', { text: '', isShow: false, timeoutID: undefined })
        }, 3000)
        store.commit('muToast', param)
    },
}

const mutations = {
    /** 앞서 걸어 둔 타이머는 취소한다 — 새 토스트가 3초를 새로 받는다 */
    'muToast': (state: ToastState, param: ToastState): void => {
        if (state.timeoutID != undefined) {
            clearTimeout(state.timeoutID)
            state.timeoutID = undefined
        }

        state.text = param.text
        state.isShow = param.isShow
        state.timeoutID = param.timeoutID
    },
}

const toast: Module<ToastState, StoreState> = { state, actions, mutations }

export default toast
